import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAction } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
})
export class ActionComponent {

  @Input() action: IAction = {
    id: 0,
    title: '',
    icon: '',
    uri: '',
    description: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private location: Location,
    private message: MessageService,
    private logger: LoggerService,
    private title: Title
  ) { }

}
